import React, { useState, useCallback } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const PdfViewer = ({ file }) => {
  const [numPages, setNumPages] = useState(null);
  const attachmentPreview = useSelector(
    (state) => state.ComplianceAssessmentSliceAPI.attachmentPreview
  );

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
  }, []);

  const documentFile = file || attachmentPreview;

  return (
    <div>
      {documentFile && (
        <Document
          renderMode="canvas"
          file={documentFile}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {Array.from({ length: numPages }, (_, index) => (
            <Page
              key={`page_${index + 1}`}
              className="pdf-page"
              pageNumber={index + 1}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          ))}
        </Document>
      )}
    </div>
  );
};

PdfViewer.propTypes = {
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default React.memo(PdfViewer);



